import { CREATE_TWITTER_PAGE_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { posts: {}, errors: null };

export default function twitterPages(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case CREATE_TWITTER_PAGE_SUCCESS:
      
     
      return { ...state, posts: action.payload.data, errors: null }
    default:
      return state;
  }
}